import { render, staticRenderFns } from "./PackingView.vue?vue&type=template&id=7ddc5cd1&scoped=true"
import script from "./PackingView.vue?vue&type=script&lang=js"
export * from "./PackingView.vue?vue&type=script&lang=js"
import style0 from "./PackingView.vue?vue&type=style&index=0&id=7ddc5cd1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddc5cd1",
  null
  
)

export default component.exports